import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const JournalPost = () => {
  const { slug } = useParams();
  return (
    <div data-testid="journal-post-page" className="min-h-screen bg-ecospora-cream pt-40 pb-32">
      <div className="container-x max-w-3xl">
        <Link
          to="/journal"
          className="inline-flex items-center gap-2 text-sm text-ecospora-charcoal/60 hover:text-ecospora-green-deep transition mb-16"
        >
          <ArrowLeft size={16} strokeWidth={1.5} /> Back to Journal
        </Link>
        <p className="text-xs font-semibold tracking-[0.18em] uppercase text-ecospora-green-mid mb-4">
          Coming soon
        </p>
        <h1 className="font-display text-4xl md:text-5xl font-bold tracking-tight text-ecospora-green-deep leading-[1.05]">
          Article in progress.
        </h1>
        <p className="mt-6 text-lg text-ecospora-charcoal/70 leading-relaxed max-w-xl">
          This piece is being written. Check back soon, or{" "}
          <Link to="/journal" className="underline decoration-ecospora-ochre underline-offset-4 text-ecospora-green-deep">
            browse other entries
          </Link>
          .
        </p>
        <p className="mt-4 text-xs text-ecospora-charcoal/40 font-mono">slug: {slug}</p>
      </div>
    </div>
  );
};

export default JournalPost;
